let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ewoC5"), load("avZlC")]).then(() => parcelRequire('9ZNsj'));